import { Component, OnInit, ViewChild } from '@angular/core';
import { Label, Color, SingleDataSet } from 'ng2-charts';
import { ChartOptions } from 'chart.js';
import { WizardResourceCloudService } from './wizard-resource-cloud.service';
import { DashboardWidgetLookup, DashboardWidgetContent } from '@serengeti/serengeti-dashboard';
import { ThemeService } from 'src/app/setting/theme/service/theme.service';
import { BaseChartDirective } from 'ng2-charts';

@DashboardWidgetLookup('WizardResourceCloudComponent')
@Component({
  selector: 'app-wizard-resource-cloud',
  templateUrl: './wizard-resource-cloud.component.html',
  styleUrls: ['./wizard-resource-cloud.component.scss']
})
export class WizardResourceCloudComponent implements OnInit, DashboardWidgetContent {

  doughnutChartLabels: Label[] = [];
  doughnutChartColors: Color[];
  doughnutChartData: SingleDataSet = [];
  doughnutChartType: Chart.ChartType = 'doughnut';
  doughnutChartOptions: ChartOptions = {
    cutoutPercentage: 70,
    plugins: {
      customCanvasBackgroundColor: {
        color: document.documentElement.style.getPropertyValue('--mainColor'),
      }
    }
  };
  doughnutData: any[];
  total = 0;

  plugins = [{
    id: 'customCanvasBackgroundColor',
    beforeDraw: (chart, args, options) => {
      const {ctx} = chart;
      ctx.save();
      ctx.fillStyle = options.color || '#99ffff';
      ctx.fillRect(0, 0, chart.width, chart.height);
      ctx.restore();
    }
  }];

	@ViewChild(BaseChartDirective, { static: false }) cloudChart: BaseChartDirective;

  constructor(
    private wizardCloudService: WizardResourceCloudService,
    private themeService: ThemeService
  ) {
    this.wizardCloudService.getData().then(data => {
      this.doughnutData = data.cloud;

      this.doughnutChartColors = [{
        borderColor: [],
        backgroundColor: []
      } as Color];
      this.doughnutChartData = [];
      this.doughnutData.forEach((cloud: any) => {
        this.doughnutChartLabels.push(cloud.label);
        // (this.doughnutChartColors[0].borderColor as string[]).push(cloud.highlight);
        (this.doughnutChartColors[0].backgroundColor as string[]).push(cloud.color);
        this.doughnutChartData.push(cloud.value);
      })
      this.total = data.total;

      this.themeService.changed().subscribe(() => {
        if (this.cloudChart.chart) {
          const mainColor = document.documentElement.style.getPropertyValue('--mainColor');
          this.cloudChart.chart.options.plugins.customCanvasBackgroundColor.color = mainColor;
          this.cloudChart.chart.update();  
        }
      });
  });

  }
  property(): boolean {
    return false;
  }

  configure(setting: any): void {
  }

  ngOnInit() {
  }

}
